// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"carousel_scroll-black__7GZ4D","wrapper":"carousel_wrapper__ZrrEk","title":"carousel_title__YY8Qs","placeholder":"carousel_placeholder__dKMEE"};